var _defs, _g, _path, _path2, _rect, _rect2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _path13, _g6, _path14, _path15, _g7, _path16, _path17, _path18, _g8, _path19, _path20, _path21, _path22, _g9, _path23, _path24, _path25, _path26, _g10, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 346.291,
    height: 207.303,
    viewBox: "0 0 346.291 207.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28431",
    "data-name": "Path 28431",
    d: "M0,0H346.291V166.817H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3979",
    "data-name": "Rectangle 3979",
    width: 346.291,
    height: 166.817,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3988",
    "data-name": "Rectangle 3988",
    width: 18.551,
    height: 10.469,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3989",
    "data-name": "Rectangle 3989",
    width: 9.09,
    height: 5.356,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3990",
    "data-name": "Rectangle 3990",
    width: 18.567,
    height: 10.469,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3992",
    "data-name": "Rectangle 3992",
    width: 18.544,
    height: 10.469,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3994",
    "data-name": "Rectangle 3994",
    width: 24.146,
    height: 26.703,
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3995",
    "data-name": "Rectangle 3995",
    width: 179.658,
    height: 26.947,
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3996",
    "data-name": "Rectangle 3996",
    width: 171.333,
    height: 25.001,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "graphic",
    transform: "translate(0 40.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16189",
    "data-name": "Group 16189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16188",
    "data-name": "Group 16188",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28287",
    "data-name": "Path 28287",
    d: "M116.943,218.137a.631.631,0,0,1-.631-.631v-3.153a.631.631,0,1,1,1.263,0v3.153a.631.631,0,0,1-.631.631",
    transform: "translate(-34.716 -63.79)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28288",
    "data-name": "Path 28288",
    d: "M59.943,160.425a.631.631,0,0,1-.631-.631V131.846a.631.631,0,0,1,.631-.631H92.154a.631.631,0,0,1,0,1.263H60.575v27.315a.631.631,0,0,1-.631.631",
    transform: "translate(-17.703 -39.164)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28289",
    "data-name": "Path 28289",
    d: "M105.943,120.7a.631.631,0,0,1-.631-.631V108.846a.631.631,0,0,1,.631-.631H170.2a.631.631,0,0,1,.631.631v2.866a.631.631,0,1,1-1.262,0v-2.235h-63v10.593a.631.631,0,0,1-.631.631",
    transform: "translate(-31.433 -32.299)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28290",
    "data-name": "Path 28290",
    d: "M95.685,142.536H85.162a1.4,1.4,0,0,1,0-2.806H95.685a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-25 -41.705)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28291",
    "data-name": "Path 28291",
    d: "M95.685,152.327H85.162a1.4,1.4,0,0,1,0-2.806H95.685a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-25 -44.628)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28292",
    "data-name": "Path 28292",
    d: "M95.685,162.12H85.162a1.4,1.4,0,1,1,0-2.806H95.685a1.4,1.4,0,1,1,0,2.806",
    transform: "translate(-25 -47.551)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28293",
    "data-name": "Path 28293",
    d: "M95.685,171.911H85.162a1.4,1.4,0,0,1,0-2.806H95.685a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-25 -50.473)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28294",
    "data-name": "Path 28294",
    d: "M95.685,181.7H85.162a1.4,1.4,0,1,1,0-2.806H95.685a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-25 -53.396)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28295",
    "data-name": "Path 28295",
    d: "M95.685,191.5H85.162a1.4,1.4,0,0,1,0-2.806H95.685a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-25 -56.318)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28296",
    "data-name": "Path 28296",
    d: "M95.685,201.287H85.162a1.4,1.4,0,0,1,0-2.806H95.685a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-25 -59.241)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28297",
    "data-name": "Path 28297",
    d: "M95.685,211.079H85.162a1.4,1.4,0,0,1,0-2.806H95.685a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-25 -62.163)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28298",
    "data-name": "Path 28298",
    d: "M328.05,90.9H316.48a.631.631,0,1,1,0-1.263h11.57a.631.631,0,0,1,0,1.263",
    transform: "translate(-94.271 -26.754)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28299",
    "data-name": "Path 28299",
    d: "M391.02,91.9H379.45a.631.631,0,1,1,0-1.263h11.57a.631.631,0,1,1,0,1.263",
    transform: "translate(-113.066 -27.053)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28300",
    "data-name": "Path 28300",
    d: "M391.02,102.338H379.45a.631.631,0,1,1,0-1.262h11.57a.631.631,0,1,1,0,1.262",
    transform: "translate(-113.066 -30.168)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28301",
    "data-name": "Path 28301",
    d: "M328.992,102.338h-11.57a.631.631,0,1,1,0-1.262h11.57a.631.631,0,1,1,0,1.262",
    transform: "translate(-94.553 -30.168)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28302",
    "data-name": "Path 28302",
    d: "M391.02,112.777H379.45a.631.631,0,1,1,0-1.263h11.57a.631.631,0,1,1,0,1.263",
    transform: "translate(-113.066 -33.284)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28303",
    "data-name": "Path 28303",
    d: "M329.05,112.777H317.48a.631.631,0,1,1,0-1.263h11.57a.631.631,0,1,1,0,1.263",
    transform: "translate(-94.57 -33.284)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28304",
    "data-name": "Path 28304",
    d: "M391.02,123.214H379.45a.631.631,0,1,1,0-1.263h11.57a.631.631,0,0,1,0,1.263",
    transform: "translate(-113.066 -36.399)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28305",
    "data-name": "Path 28305",
    d: "M393.609,133.653h-5.487a.631.631,0,1,1,0-1.263h5.487a.631.631,0,1,1,0,1.263",
    transform: "translate(-115.654 -39.515)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28306",
    "data-name": "Path 28306",
    d: "M393.609,144.09h-5.487a.631.631,0,1,1,0-1.263h5.487a.631.631,0,1,1,0,1.263",
    transform: "translate(-115.654 -42.63)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28307",
    "data-name": "Path 28307",
    d: "M393.608,154.527h-5.487a.632.632,0,1,1,0-1.263h5.487a.632.632,0,0,1,0,1.263",
    transform: "translate(-115.654 -45.745)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28308",
    "data-name": "Path 28308",
    d: "M393.608,164.966h-5.487a.632.632,0,1,1,0-1.263h5.487a.632.632,0,0,1,0,1.263",
    transform: "translate(-115.654 -48.861)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28309",
    "data-name": "Path 28309",
    d: "M393.608,175.4h-5.487a.632.632,0,1,1,0-1.263h5.487a.632.632,0,0,1,0,1.263",
    transform: "translate(-115.654 -51.976)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28310",
    "data-name": "Path 28310",
    d: "M393.608,185.841h-5.487a.632.632,0,1,1,0-1.263h5.487a.632.632,0,0,1,0,1.263",
    transform: "translate(-115.654 -55.091)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28311",
    "data-name": "Path 28311",
    d: "M393.608,196.279h-5.487a.632.632,0,1,1,0-1.263h5.487a.632.632,0,0,1,0,1.263",
    transform: "translate(-115.654 -58.207)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28312",
    "data-name": "Path 28312",
    d: "M393.608,206.717h-5.487a.632.632,0,1,1,0-1.263h5.487a.632.632,0,0,1,0,1.263",
    transform: "translate(-115.654 -61.322)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28313",
    "data-name": "Path 28313",
    d: "M121.476,118.536h-6.314a1.4,1.4,0,1,1,0-2.806h6.314a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-33.954 -34.542)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28314",
    "data-name": "Path 28314",
    d: "M142.782,118.536h-6.314a1.4,1.4,0,0,1,0-2.806h6.314a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-40.313 -34.542)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28315",
    "data-name": "Path 28315",
    d: "M164.087,118.536h-6.314a1.4,1.4,0,0,1,0-2.806h6.314a1.4,1.4,0,1,1,0,2.806",
    transform: "translate(-46.672 -34.542)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28316",
    "data-name": "Path 28316",
    d: "M185.393,118.536h-6.314a1.4,1.4,0,0,1,0-2.806h6.314a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-53.031 -34.542)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28317",
    "data-name": "Path 28317",
    d: "M74.371,142.536H70.162a1.4,1.4,0,0,1,0-2.806h4.209a1.4,1.4,0,1,1,0,2.806",
    transform: "translate(-20.523 -41.705)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28318",
    "data-name": "Path 28318",
    d: "M74.371,152.328h-4.21a1.4,1.4,0,1,1,0-2.806h4.21a1.4,1.4,0,1,1,0,2.806",
    transform: "translate(-20.522 -44.628)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28319",
    "data-name": "Path 28319",
    d: "M74.371,162.12H70.162a1.4,1.4,0,1,1,0-2.806h4.209a1.4,1.4,0,1,1,0,2.806",
    transform: "translate(-20.523 -47.551)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28320",
    "data-name": "Path 28320",
    d: "M74.371,171.911H70.162a1.4,1.4,0,0,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-20.523 -50.473)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28321",
    "data-name": "Path 28321",
    d: "M130.6,161.734H126.39a1.4,1.4,0,1,1,0-2.806H130.6a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-37.305 -47.435)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28322",
    "data-name": "Path 28322",
    d: "M144.273,161.734h-4.209a1.4,1.4,0,1,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-41.386 -47.435)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28323",
    "data-name": "Path 28323",
    d: "M130.6,171.526h-4.21a1.4,1.4,0,1,1,0-2.806h4.21a1.4,1.4,0,1,1,0,2.806",
    transform: "translate(-37.305 -50.358)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28324",
    "data-name": "Path 28324",
    d: "M130.6,181.318H126.39a1.4,1.4,0,1,1,0-2.806H130.6a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-37.305 -53.281)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28325",
    "data-name": "Path 28325",
    d: "M130.6,191.109H126.39a1.4,1.4,0,1,1,0-2.806H130.6a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-37.305 -56.203)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28326",
    "data-name": "Path 28326",
    d: "M344.03,83.48h-4.209a1.4,1.4,0,1,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-101.008 -24.079)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28327",
    "data-name": "Path 28327",
    d: "M344.029,94.973h-4.211a1.4,1.4,0,0,1,0-2.806h4.211a1.4,1.4,0,1,1,0,2.806",
    transform: "translate(-101.007 -27.509)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28328",
    "data-name": "Path 28328",
    d: "M357.592,83.48h-4.209a1.4,1.4,0,0,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-105.056 -24.079)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28329",
    "data-name": "Path 28329",
    d: "M357.592,94.973h-4.209a1.4,1.4,0,0,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-105.056 -27.509)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28330",
    "data-name": "Path 28330",
    d: "M344.029,106.466h-4.211a1.4,1.4,0,0,1,0-2.806h4.211a1.4,1.4,0,1,1,0,2.806",
    transform: "translate(-101.007 -30.939)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28331",
    "data-name": "Path 28331",
    d: "M357.592,106.466h-4.209a1.4,1.4,0,0,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-105.056 -30.939)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28332",
    "data-name": "Path 28332",
    d: "M344.029,117.958h-4.211a1.4,1.4,0,0,1,0-2.806h4.211a1.4,1.4,0,1,1,0,2.806",
    transform: "translate(-101.007 -34.37)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28333",
    "data-name": "Path 28333",
    d: "M357.592,117.958h-4.209a1.4,1.4,0,0,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-105.056 -34.37)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28334",
    "data-name": "Path 28334",
    d: "M371.156,83.48h-4.209a1.4,1.4,0,1,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-109.104 -24.079)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28335",
    "data-name": "Path 28335",
    d: "M371.156,94.973h-4.209a1.4,1.4,0,1,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-109.104 -27.509)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28336",
    "data-name": "Path 28336",
    d: "M371.156,106.466h-4.209a1.4,1.4,0,1,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-109.104 -30.939)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28337",
    "data-name": "Path 28337",
    d: "M371.156,117.958h-4.209a1.4,1.4,0,1,1,0-2.806h4.209a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-109.104 -34.37)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28338",
    "data-name": "Path 28338",
    d: "M130.6,199.7H126.39a1.4,1.4,0,1,1,0-2.806H130.6a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-37.305 -58.768)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28339",
    "data-name": "Path 28339",
    d: "M130.6,209.493H126.39a1.4,1.4,0,0,1,0-2.806H130.6a1.4,1.4,0,0,1,0,2.806",
    transform: "translate(-37.305 -61.69)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28340",
    "data-name": "Path 28340",
    d: "M147.008,151.479H121.491a.631.631,0,0,1,0-1.263h25.517a.631.631,0,1,1,0,1.263",
    transform: "translate(-36.073 -44.835)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28342",
    "data-name": "Path 28342",
    d: "M372.927,175.838a.631.631,0,0,1-.631-.631V77.189l-12.115-4.71H329.728L317.111,77.2V105.57a.631.631,0,0,1-1.263,0V76.758a.631.631,0,0,1,.41-.591l13.133-4.911a.615.615,0,0,1,.222-.041H360.3a.622.622,0,0,1,.229.044l12.628,4.911a.631.631,0,0,1,.4.589v98.449a.631.631,0,0,1-.631.631",
    transform: "translate(-94.271 -21.256)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28343",
    "data-name": "Path 28343",
    d: "M334.437,109.186a.631.631,0,0,1-.631-.631V81.846a.631.631,0,1,1,1.263,0v26.708a.631.631,0,0,1-.631.631",
    transform: "translate(-99.631 -24.24)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28344",
    "data-name": "Path 28344",
    d: "M379.45,217.477a.631.631,0,0,1-.631-.631v-7.464a.631.631,0,1,1,1.263,0v7.464a.631.631,0,0,1-.631.631",
    transform: "translate(-113.066 -62.306)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28345",
    "data-name": "Path 28345",
    d: "M379.45,116.537a.631.631,0,0,1-.631-.631V81.846a.631.631,0,1,1,1.263,0v34.059a.631.631,0,0,1-.631.631",
    transform: "translate(-113.066 -24.24)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36229",
    "data-name": "Group 36229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28277",
    "data-name": "Path 28277",
    d: "M50.987,188.147a9.714,9.714,0,1,0,9.715-9.715,9.715,9.715,0,0,0-9.715,9.715",
    transform: "translate(-15.218 -53.257)",
    fill: "rgba(25,188,156,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28278",
    "data-name": "Path 28278",
    d: "M58.4,198.265a10.416,10.416,0,1,1,10.416-10.416A10.428,10.428,0,0,1,58.4,198.265m0-19.429a9.013,9.013,0,1,0,9.013,9.013,9.024,9.024,0,0,0-9.013-9.013",
    transform: "translate(-14.322 -52.958)",
    fill: "#12997e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28280",
    "data-name": "Path 28280",
    d: "M60.557,193.029a.7.7,0,0,1-.431-.148l-2.909-2.264a.7.7,0,0,1,.861-1.107l2.909,2.264a.7.7,0,0,1-.431,1.255",
    transform: "translate(-16.997 -56.519)",
    fill: "#12997e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28281",
    "data-name": "Path 28281",
    d: "M62.306,197.5a.7.7,0,0,1-.348-1.311l5.162-2.939a.7.7,0,0,1,.695,1.22l-5.162,2.939a.7.7,0,0,1-.347.092",
    transform: "translate(-18.387 -57.652)",
    fill: "#12997e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28279",
    "data-name": "Path 28279",
    d: "M62.229,210.383a.7.7,0,0,1-.7-.7v-24.61a.7.7,0,1,1,1.4,0v24.61a.7.7,0,0,1-.7.7",
    transform: "translate(-18.364 -55.029)",
    fill: "#12997e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36230",
    "data-name": "Group 36230",
    transform: "translate(251.945 -8.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28277-2",
    "data-name": "Path 28277",
    d: "M50.987,190.537a12.1,12.1,0,1,0,12.1-12.1,12.106,12.106,0,0,0-12.1,12.1",
    transform: "translate(-14.7 -53.084)",
    fill: "rgba(25,188,156,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28278-2",
    "data-name": "Path 28278",
    d: "M60.965,203.39a12.979,12.979,0,1,1,12.979-12.978A12.993,12.993,0,0,1,60.965,203.39m0-24.209A11.23,11.23,0,1,0,72.2,190.412a11.244,11.244,0,0,0-11.231-11.231",
    transform: "translate(-14.322 -52.958)",
    fill: "#12997e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28280-2",
    "data-name": "Path 28280",
    d: "M61.445,193.931a.867.867,0,0,1-.537-.184l-3.624-2.821a.874.874,0,0,1,1.073-1.379l3.625,2.821a.874.874,0,0,1-.538,1.564",
    transform: "translate(-15.45 -54.46)",
    fill: "#12997e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28281-2",
    "data-name": "Path 28281",
    d: "M62.479,198.57a.874.874,0,0,1-.434-1.634l6.432-3.663a.875.875,0,0,1,.865,1.52l-6.432,3.662a.871.871,0,0,1-.432.115",
    transform: "translate(-16.036 -54.938)",
    fill: "#12997e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28279-2",
    "data-name": "Path 28279",
    d: "M62.4,216.784a.874.874,0,0,1-.874-.874V185.244a.874.874,0,1,1,1.748,0V215.91a.874.874,0,0,1-.874.874",
    transform: "translate(-16.027 -53.832)",
    fill: "#12997e"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28364",
    "data-name": "Path 28364",
    d: "M125.427,133.818H115v11.29l.6-9.163,8,.014Z",
    transform: "translate(-34.323 -39.941)",
    fill: "#4b5559"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16235",
    "data-name": "Group 16235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16234",
    "data-name": "Group 16234",
    clipPath: "url(#clip-path-2)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28365",
    "data-name": "Path 28365",
    d: "M114.7,145.511h-.023a.7.7,0,0,1-.678-.7V133.52a.7.7,0,0,1,.7-.7h10.431a.7.7,0,1,1,0,1.4H115.4v.724l7.9.014a.7.7,0,0,1,0,1.4h0l-7.337-.013-.56,8.507a.7.7,0,0,1-.7.655",
    transform: "translate(-34.024 -39.642)",
    fill: "#4b5559"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3986",
    "data-name": "Rectangle 3986",
    width: 66.579,
    height: 11.546,
    transform: "translate(189.089 135.972)",
    fill: "#4b5559"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3987",
    "data-name": "Rectangle 3987",
    width: 39.87,
    height: 11.546,
    transform: "translate(97.94 135.972)",
    fill: "#4b5559"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28366",
    "data-name": "Path 28366",
    d: "M159.354,202.457a9.276,9.276,0,1,0,9.283-9.28,9.279,9.279,0,0,0-9.283,9.28",
    transform: "translate(-47.563 -57.658)",
    fill: "#555d60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16209",
    "data-name": "Group 16209",
    transform: "translate(111.791 143.598)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16208",
    "data-name": "Group 16208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16207",
    "data-name": "Group 16207",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28367",
    "data-name": "Path 28367",
    d: "M168.637,212.8a9.278,9.278,0,0,1-9.2-8.108,9.083,9.083,0,0,0-.083,1.2,9.276,9.276,0,0,0,18.551,0,7.933,7.933,0,0,0-.076-1.2,9.273,9.273,0,0,1-9.191,8.108",
    transform: "translate(-159.354 -204.693)",
    fill: "#3d5259"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28368",
    "data-name": "Path 28368",
    d: "M168.339,212.129a9.975,9.975,0,1,1,9.969-9.969,9.988,9.988,0,0,1-9.969,9.969m0-18.548a8.572,8.572,0,1,0,8.566,8.578,8.59,8.59,0,0,0-8.566-8.578",
    transform: "translate(-47.264 -57.36)",
    fill: "#4b5559"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28369",
    "data-name": "Path 28369",
    d: "M170.653,209.011a4.549,4.549,0,1,1,4.544-4.544,4.553,4.553,0,0,1-4.544,4.544",
    transform: "translate(-49.578 -59.668)",
    fill: "#ecf0f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16212",
    "data-name": "Group 16212",
    transform: "translate(116.529 143.226)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16211",
    "data-name": "Group 16211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16210",
    "data-name": "Group 16210",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28370",
    "data-name": "Path 28370",
    d: "M170.652,207.9a4.537,4.537,0,0,1-4.469-3.736,4.178,4.178,0,0,0-.075.809,4.545,4.545,0,1,0,9.09,0,5.291,5.291,0,0,0-.072-.809,4.543,4.543,0,0,1-4.473,3.736",
    transform: "translate(-166.107 -204.162)",
    fill: "#ecf0f1"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28371",
    "data-name": "Path 28371",
    d: "M170.056,199.315a4.549,4.549,0,1,1-4.546,4.555,4.551,4.551,0,0,1,4.546-4.555m0-1.4A5.952,5.952,0,1,0,176,203.87a5.96,5.96,0,0,0-5.947-5.958",
    transform: "translate(-48.981 -59.071)",
    fill: "#4b5559"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28372",
    "data-name": "Path 28372",
    d: "M169.926,203.578c0,.619.818,1.127,1.825,1.127s1.837-.509,1.837-1.127-.828-1.127-1.837-1.127-1.825.5-1.825,1.127",
    transform: "translate(-50.718 -60.426)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28373",
    "data-name": "Path 28373",
    d: "M286.558,202.457a9.284,9.284,0,1,0,9.291-9.281,9.283,9.283,0,0,0-9.291,9.281",
    transform: "translate(-85.529 -57.657)",
    fill: "#555d60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16215",
    "data-name": "Group 16215",
    transform: "translate(201.029 143.598)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16214",
    "data-name": "Group 16214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16213",
    "data-name": "Group 16213",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28374",
    "data-name": "Path 28374",
    d: "M295.849,212.8a9.289,9.289,0,0,1-9.2-8.11,9.279,9.279,0,1,0,18.48,1.2,8.029,8.029,0,0,0-.088-1.2,9.274,9.274,0,0,1-9.189,8.11",
    transform: "translate(-286.558 -204.693)",
    fill: "#3d5259"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28375",
    "data-name": "Path 28375",
    d: "M295.551,212.128a9.976,9.976,0,1,1,9.978-9.969,9.992,9.992,0,0,1-9.978,9.969m0-18.549a8.573,8.573,0,1,0,8.575,8.58,8.594,8.594,0,0,0-8.575-8.58",
    transform: "translate(-85.231 -57.359)",
    fill: "#4b5559"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28376",
    "data-name": "Path 28376",
    d: "M297.866,209.011a4.549,4.549,0,1,1,4.54-4.543,4.553,4.553,0,0,1-4.54,4.543",
    transform: "translate(-87.547 -59.668)",
    fill: "#ecf0f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16218",
    "data-name": "Group 16218",
    transform: "translate(205.77 143.226)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16217",
    "data-name": "Group 16217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16216",
    "data-name": "Group 16216",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28377",
    "data-name": "Path 28377",
    d: "M297.866,207.9a4.529,4.529,0,0,1-4.472-3.736,5.026,5.026,0,0,0-.077.809,4.545,4.545,0,1,0,9.09,0,6.084,6.084,0,0,0-.068-.809,4.533,4.533,0,0,1-4.472,3.736",
    transform: "translate(-293.317 -204.162)",
    fill: "#ecf0f1"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28378",
    "data-name": "Path 28378",
    d: "M297.27,199.315a4.549,4.549,0,1,1-4.549,4.556,4.552,4.552,0,0,1,4.549-4.556m0-1.4a5.952,5.952,0,1,0,5.943,5.959,5.962,5.962,0,0,0-5.943-5.959",
    transform: "translate(-86.95 -59.071)",
    fill: "#4b5559"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28379",
    "data-name": "Path 28379",
    d: "M297.146,203.578c0,.62.81,1.127,1.831,1.127,1,0,1.825-.507,1.825-1.127s-.83-1.129-1.825-1.129c-1.021,0-1.831.5-1.831,1.129",
    transform: "translate(-88.689 -60.425)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28380",
    "data-name": "Path 28380",
    d: "M319.2,202.457a9.272,9.272,0,1,0,9.278-9.281,9.266,9.266,0,0,0-9.278,9.281",
    transform: "translate(-95.271 -57.657)",
    fill: "#555d60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16221",
    "data-name": "Group 16221",
    transform: "translate(223.927 143.598)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16220",
    "data-name": "Group 16220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16219",
    "data-name": "Group 16219",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28381",
    "data-name": "Path 28381",
    d: "M328.475,212.8a9.291,9.291,0,0,1-9.212-8.11,9.278,9.278,0,1,0,18.48,1.2,8.021,8.021,0,0,0-.088-1.2,9.26,9.26,0,0,1-9.179,8.11",
    transform: "translate(-319.198 -204.693)",
    fill: "#3d5259"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28382",
    "data-name": "Path 28382",
    d: "M328.176,212.128a9.976,9.976,0,1,1,9.969-9.969,9.986,9.986,0,0,1-9.969,9.969m0-18.549a8.573,8.573,0,1,0,8.566,8.58,8.588,8.588,0,0,0-8.566-8.58",
    transform: "translate(-94.973 -57.359)",
    fill: "#4b5559"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28383",
    "data-name": "Path 28383",
    d: "M330.483,209.011a4.549,4.549,0,1,1,4.532-4.543,4.554,4.554,0,0,1-4.532,4.543",
    transform: "translate(-97.279 -59.668)",
    fill: "#ecf0f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16224",
    "data-name": "Group 16224",
    transform: "translate(228.646 143.226)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16223",
    "data-name": "Group 16223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16222",
    "data-name": "Group 16222",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28384",
    "data-name": "Path 28384",
    d: "M330.481,207.9a4.537,4.537,0,0,1-4.47-3.736,4.183,4.183,0,0,0-.086.809,4.545,4.545,0,1,0,9.09,0,5.1,5.1,0,0,0-.061-.809,4.543,4.543,0,0,1-4.472,3.736",
    transform: "translate(-325.925 -204.162)",
    fill: "#ecf0f1"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28385",
    "data-name": "Path 28385",
    d: "M329.886,199.315a4.549,4.549,0,1,1-4.558,4.556,4.55,4.55,0,0,1,4.558-4.556m0-1.4a5.952,5.952,0,1,0,5.935,5.959,5.967,5.967,0,0,0-5.935-5.959",
    transform: "translate(-96.682 -59.071)",
    fill: "#4b5559"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28386",
    "data-name": "Path 28386",
    d: "M329.762,203.578c0,.62.8,1.127,1.825,1.127s1.825-.507,1.825-1.127-.816-1.129-1.825-1.129-1.825.5-1.825,1.129",
    transform: "translate(-98.424 -60.425)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28387",
    "data-name": "Path 28387",
    d: "M371.336,183.255a1.2,1.2,0,0,0,1.2-1.191V137.557a1.194,1.194,0,0,0-1.2-1.191H348.393v46.889Z",
    transform: "translate(-103.985 -40.701)",
    fill: "#fff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16227",
    "data-name": "Group 16227",
    transform: "translate(244.408 115.851)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16226",
    "data-name": "Group 16226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16225",
    "data-name": "Group 16225",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28388",
    "data-name": "Path 28388",
    d: "M348.393,165.141v26.7h22.943a1.194,1.194,0,0,0,1.2-1.191V165.141Z",
    transform: "translate(-348.393 -165.141)",
    fill: "#19bc9c"
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28389",
    "data-name": "Path 28389",
    d: "M371.037,183.658H348.095a.7.7,0,0,1-.7-.7V136.068a.7.7,0,0,1,.7-.7h22.943a1.9,1.9,0,0,1,1.9,1.892v44.507a1.9,1.9,0,0,1-1.9,1.893m-22.241-1.4h22.241a.491.491,0,0,0,.5-.49V137.258a.5.5,0,0,0-.5-.489H348.8Z",
    transform: "translate(-103.687 -40.403)",
    fill: "#4b5559"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28390",
    "data-name": "Path 28390",
    d: "M115.062,195.076v-7.562s-4.18,1.442-4.18,3.983v4.488l1.395,1.454v3.574c0,2.53,4.178,2.53,4.178,2.53v-8.468Z",
    transform: "translate(-33.095 -55.967)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28391",
    "data-name": "Path 28391",
    d: "M116.156,203.947c-1.813,0-4.88-.681-4.88-3.233v-3.292l-1.2-1.251a.706.706,0,0,1-.2-.486V191.2c0-3.005,4.462-4.58,4.653-4.646a.7.7,0,0,1,.93.663v6.86h.692a.7.7,0,0,1,.7.7v8.469a.7.7,0,0,1-.7.7m-4.871-8.543,1.2,1.251a.7.7,0,0,1,.2.486v3.574c0,1.273,1.759,1.66,2.775,1.778v-7.015h-.692a.7.7,0,0,1-.7-.7v-6.5c-1.2.586-2.777,1.646-2.777,2.926Z",
    transform: "translate(-32.797 -55.669)",
    fill: "#4b5559"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28392",
    "data-name": "Path 28392",
    d: "M293.339,125.232H133.646c-13.753,0-17.575,38.965-17.575,38.965l.26,20.758h27.5s.3-9.4,3.533-9.4h16.692c2.618,0,3.528,9.4,3.528,9.4h65.488s-.242-9.4,3.525-9.4h16.712l1.463,2.37h2.936l1.463-2.37h16.712c3.165,0,3.524,9.4,3.524,9.4h17.01V128.322a3.09,3.09,0,0,0-3.083-3.09",
    transform: "translate(-34.644 -37.378)",
    fill: "#fff"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16230",
    "data-name": "Group 16230",
    transform: "translate(82.12 120.629)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16229",
    "data-name": "Group 16229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16228",
    "data-name": "Group 16228",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28393",
    "data-name": "Path 28393",
    d: "M169.033,171.952c-17.211,0-45.4,11.148-45.66,11.25l-6.313,2.431.181,13.266h26.889s.028-9.4,3.533-9.4h16.692c2.217,0,3.527,9.4,3.527,9.4H233.37s-.485-9.4,3.525-9.4h16.712l1.463,2.37h2.936l1.463-2.37h16.713c4.112,0,3.523,9.4,3.523,9.4h17.01V171.952Z",
    transform: "translate(-117.058 -171.952)",
    fill: "#19bc9c"
  }))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28394",
    "data-name": "Path 28394",
    d: "M296.123,185.358h-17.01a.7.7,0,0,1-.7-.675c-.136-3.52-1.127-8.726-2.824-8.726h-15.77l-1.88,2.133a.7.7,0,0,1-.526.238h-2.935a.7.7,0,0,1-.526-.238l-1.88-2.133H236.3a1.277,1.277,0,0,0-.939.429c-1.521,1.526-1.872,6.257-1.885,8.131a.652.652,0,0,1,.014.139.7.7,0,0,1-.7.7h-65.5a.7.7,0,0,1-.695-.6c-.631-4.522-2.008-8.8-2.833-8.8H147.068c-1.74,0-2.718,5.2-2.831,8.722a.7.7,0,0,1-.7.679h-27.5a.7.7,0,0,1-.7-.692l-.261-20.758a.712.712,0,0,1,0-.077c.159-1.617,4.048-39.6,18.273-39.6H293.041a3.792,3.792,0,0,1,3.784,3.791v56.633a.7.7,0,0,1-.7.7m-16.344-1.4h15.642V128.023a2.387,2.387,0,0,0-2.381-2.388H133.347c-12.786,0-16.729,36.9-16.872,38.294l.251,20.026h26.14c.145-2.578.846-9.4,4.2-9.4h16.692c2.394,0,3.643,6.154,4.135,9.4h64.191c.055-1.873.386-6.657,2.283-8.559a2.664,2.664,0,0,1,1.932-.842h16.085a.7.7,0,0,1,.526.237l1.88,2.133h2.3l1.88-2.133a.7.7,0,0,1,.526-.237h16.086c3.3,0,4.031,6.827,4.191,9.4",
    transform: "translate(-34.345 -37.08)",
    fill: "#4b5559"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28395",
    "data-name": "Path 28395",
    d: "M135.594,129.637c-6.879,0-11.595,19.962-13,35.26,0,0,9.055-3.627,20.3-6.84v-28.42Z",
    transform: "translate(-36.592 -38.693)",
    fill: "#738084"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28396",
    "data-name": "Path 28396",
    d: "M151.538,129.637v28.42c9.027-2.595,19.467-4.912,27.785-4.912h124.6V129.637Z",
    transform: "translate(-45.23 -38.693)",
    fill: "#738084"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28397",
    "data-name": "Path 28397",
    d: "M122.921,170.6c-.123,1.035-.231,2.051-.322,3.059,0,0,29.417-11.752,48.087-11.752h124.6v-2.918h-124.6c-17.5,0-44.663,10.316-47.765,11.612",
    transform: "translate(-36.592 -47.452)",
    fill: "#4b5559"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16233",
    "data-name": "Group 16233",
    transform: "translate(87.362 90.944)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16232",
    "data-name": "Group 16232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16231",
    "data-name": "Group 16231",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28398",
    "data-name": "Path 28398",
    d: "M216.449,134.712c28.782,0,58.86-1.155,79.415.224v-5.3H136.171c-5.4,0-9.473,12.3-11.64,25,21.769-12.2,55.9-19.927,91.918-19.927",
    transform: "translate(-124.531 -129.637)",
    fill: "#fff"
  }))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28399",
    "data-name": "Path 28399",
    d: "M122.3,165.3a.7.7,0,0,1-.7-.765c1.136-12.416,5.462-35.9,13.694-35.9H294.989a.7.7,0,0,1,.7.7v23.508a.7.7,0,0,1-.7.7h-124.6c-18.318,0-47.534,11.584-47.826,11.7a.7.7,0,0,1-.26.051m13-35.26c-5.586,0-10.516,16.833-12.188,33.492,5.47-2.093,30.7-11.387,47.28-11.387h123.9v-22.1Z",
    transform: "translate(-36.294 -38.394)",
    fill: "#4b5559"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28400",
    "data-name": "Path 28400",
    d: "M151.475,186.417a.7.7,0,0,1-.7-.7V129.339a.7.7,0,1,1,1.4,0v56.377a.7.7,0,0,1-.7.7",
    transform: "translate(-45.001 -38.394)",
    fill: "#4b5559"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28401",
    "data-name": "Path 28401",
    d: "M122.3,201.674a.7.7,0,0,1-.7-.7V179.6a.7.7,0,1,1,1.4,0v21.373a.7.7,0,0,1-.7.7",
    transform: "translate(-36.294 -53.396)",
    fill: "#4b5559"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28402",
    "data-name": "Path 28402",
    d: "M191.133,153.569a.7.7,0,0,1-.7-.7V129.339a.7.7,0,1,1,1.4,0v23.529a.7.7,0,0,1-.7.7",
    transform: "translate(-56.838 -38.394)",
    fill: "#4b5559"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28403",
    "data-name": "Path 28403",
    d: "M320.169,153.569a.7.7,0,0,1-.7-.7V129.339a.7.7,0,1,1,1.4,0v23.529a.7.7,0,0,1-.7.7",
    transform: "translate(-95.352 -38.394)",
    fill: "#4b5559"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28404",
    "data-name": "Path 28404",
    d: "M234.139,153.569a.7.7,0,0,1-.7-.7V129.339a.7.7,0,1,1,1.4,0v23.529a.7.7,0,0,1-.7.7",
    transform: "translate(-69.674 -38.394)",
    fill: "#4b5559"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28405",
    "data-name": "Path 28405",
    d: "M277.163,153.569a.7.7,0,0,1-.7-.7V129.339a.7.7,0,1,1,1.4,0v23.529a.7.7,0,0,1-.7.7",
    transform: "translate(-82.516 -38.394)",
    fill: "#4b5559"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28406",
    "data-name": "Path 28406",
    d: "M117.529,184.683h0c-.187,0-.4-.012-.64-.026-.28-.015-.6-.034-.967-.034a.7.7,0,0,1-.7-.7v-4a.7.7,0,0,1,.786-.7,3.66,3.66,0,0,1,3.222,3.628,1.932,1.932,0,0,1-.448,1.418,1.7,1.7,0,0,1-1.252.411m-.9-1.444.344.018c.21.012.4.023.561.023a1.207,1.207,0,0,0,.276-.022c-.009-.02.02-.138.02-.4a2.252,2.252,0,0,0-1.2-1.99Z",
    transform: "translate(-34.39 -53.492)",
    fill: "#4b5559"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28407",
    "data-name": "Path 28407",
    d: "M362.871,198.429h-9.032a.7.7,0,1,1,0-1.4h9.032a.7.7,0,1,1,0,1.4",
    transform: "translate(-105.401 -58.807)",
    fill: "#4b5559"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28408",
    "data-name": "Path 28408",
    d: "M362.871,201.909h-9.032a.7.7,0,1,1,0-1.4h9.032a.7.7,0,1,1,0,1.4",
    transform: "translate(-105.401 -59.845)",
    fill: "#4b5559"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28409",
    "data-name": "Path 28409",
    d: "M362.871,205.337h-9.032a.7.7,0,1,1,0-1.4h9.032a.7.7,0,1,1,0,1.4",
    transform: "translate(-105.401 -60.868)",
    fill: "#4b5559"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28410",
    "data-name": "Path 28410",
    d: "M274.119,198.429h-9.041a.7.7,0,1,1,0-1.4h9.041a.7.7,0,1,1,0,1.4",
    transform: "translate(-78.909 -58.807)",
    fill: "#4b5559"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28411",
    "data-name": "Path 28411",
    d: "M274.119,201.909h-9.041a.7.7,0,1,1,0-1.4h9.041a.7.7,0,1,1,0,1.4",
    transform: "translate(-78.909 -59.845)",
    fill: "#4b5559"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28412",
    "data-name": "Path 28412",
    d: "M274.119,205.337h-9.041a.7.7,0,1,1,0-1.4h9.041a.7.7,0,1,1,0,1.4",
    transform: "translate(-78.909 -60.868)",
    fill: "#4b5559"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28413",
    "data-name": "Path 28413",
    d: "M305.274,181.143H156.761a.7.7,0,0,1,0-1.4H305.274a.7.7,0,0,1,0,1.4",
    transform: "translate(-46.579 -53.647)",
    fill: "#4b5559"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28414",
    "data-name": "Path 28414",
    d: "M112.771,131.055a1.959,1.959,0,0,0-1.959,1.955v11.8a1.962,1.962,0,0,0,1.959,1.957h2.214V131.055Z",
    transform: "translate(-33.074 -39.116)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28415",
    "data-name": "Path 28415",
    d: "M114.687,147.172h-2.214a2.663,2.663,0,0,1-2.661-2.658v-11.8a2.662,2.662,0,0,1,2.661-2.657h2.214a.7.7,0,0,1,.7.7v15.714a.7.7,0,0,1-.7.7m-2.214-15.714a1.257,1.257,0,0,0-1.258,1.254v11.8a1.257,1.257,0,0,0,1.258,1.255h1.512V131.458Z",
    transform: "translate(-32.776 -38.818)",
    fill: "#4b5559"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28416",
    "data-name": "Path 28416",
    d: "M192.554,200.244a.7.7,0,0,1-.7-.7V183.958a.7.7,0,1,1,1.4,0v15.585a.7.7,0,0,1-.7.7",
    transform: "translate(-57.262 -54.697)",
    fill: "#4b5559"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28417",
    "data-name": "Path 28417",
    d: "M258.592,200.244a.7.7,0,0,1-.7-.7V183.958a.7.7,0,1,1,1.4,0v15.585a.7.7,0,0,1-.7.7",
    transform: "translate(-76.973 -54.697)",
    fill: "#4b5559"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28418",
    "data-name": "Path 28418",
    d: "M225.126,200.244a.7.7,0,0,1-.7-.7V183.958a.7.7,0,0,1,1.4,0v15.585a.7.7,0,0,1-.7.7",
    transform: "translate(-66.984 -54.697)",
    fill: "#4b5559"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28419",
    "data-name": "Path 28419",
    d: "M209.287,195.777H206.2a.7.7,0,1,1,0-1.4h3.083a.7.7,0,1,1,0,1.4",
    transform: "translate(-61.337 -58.015)",
    fill: "#4b5559"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28420",
    "data-name": "Path 28420",
    d: "M242.74,195.777h-3.087a.7.7,0,0,1,0-1.4h3.087a.7.7,0,1,1,0,1.4",
    transform: "translate(-71.32 -58.015)",
    fill: "#4b5559"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16237",
    "data-name": "Group 16237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16236",
    "data-name": "Group 16236",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28421",
    "data-name": "Path 28421",
    d: "M484.667,220.693h-1.755a.7.7,0,0,1,0-1.4h1.755a.7.7,0,1,1,0,1.4",
    transform: "translate(-143.926 -65.452)",
    fill: "#4b5559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28422",
    "data-name": "Path 28422",
    d: "M463.463,220.693H429.5a.7.7,0,1,1,0-1.4h33.963a.7.7,0,0,1,0,1.4",
    transform: "translate(-127.984 -65.452)",
    fill: "#4b5559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28423",
    "data-name": "Path 28423",
    d: "M340.624,220.693H141.131a.7.7,0,1,1,0-1.4H340.624a.7.7,0,1,1,0,1.4",
    transform: "translate(-41.914 -65.452)",
    fill: "#4b5559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28424",
    "data-name": "Path 28424",
    d: "M137.1,220.693h-.915a.7.7,0,1,1,0-1.4h.915a.7.7,0,1,1,0,1.4",
    transform: "translate(-40.437 -65.452)",
    fill: "#4b5559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28425",
    "data-name": "Path 28425",
    d: "M132.048,220.693h-2.758a.7.7,0,1,1,0-1.4h2.758a.7.7,0,1,1,0,1.4",
    transform: "translate(-38.38 -65.452)",
    fill: "#4b5559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28426",
    "data-name": "Path 28426",
    d: "M93.016,220.693h-78.1a.7.7,0,1,1,0-1.4h78.1a.7.7,0,1,1,0,1.4",
    transform: "translate(-4.242 -65.452)",
    fill: "#4b5559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28427",
    "data-name": "Path 28427",
    d: "M10.229,220.693H8.619a.7.7,0,1,1,0-1.4h1.61a.7.7,0,1,1,0,1.4",
    transform: "translate(-2.363 -65.452)",
    fill: "#4b5559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28428",
    "data-name": "Path 28428",
    d: "M30.964,236.895H26.755a1.052,1.052,0,1,1,0-2.1h4.209a1.052,1.052,0,1,1,0,2.1",
    transform: "translate(-7.672 -70.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28429",
    "data-name": "Path 28429",
    d: "M327.615,236.895H319.05a1.052,1.052,0,1,1,0-2.1h8.565a1.052,1.052,0,1,1,0,2.1m-17.13,0h-8.566a1.052,1.052,0,1,1,0-2.1h8.566a1.052,1.052,0,1,1,0,2.1m-17.131,0h-8.565a1.052,1.052,0,0,1,0-2.1h8.565a1.052,1.052,0,1,1,0,2.1m-17.131,0h-8.565a1.052,1.052,0,1,1,0-2.1h8.565a1.052,1.052,0,1,1,0,2.1m-17.13,0h-8.566a1.052,1.052,0,1,1,0-2.1h8.566a1.052,1.052,0,1,1,0,2.1m-17.13,0H233.4a1.052,1.052,0,1,1,0-2.1h8.566a1.052,1.052,0,1,1,0,2.1m-17.13,0h-8.566a1.052,1.052,0,1,1,0-2.1h8.566a1.052,1.052,0,1,1,0,2.1m-17.131,0h-8.565a1.052,1.052,0,1,1,0-2.1H207.7a1.052,1.052,0,1,1,0,2.1m-17.131,0h-8.565a1.052,1.052,0,1,1,0-2.1h8.565a1.052,1.052,0,1,1,0,2.1m-17.13,0h-8.566a1.052,1.052,0,1,1,0-2.1h8.566a1.052,1.052,0,1,1,0,2.1m-17.131,0h-8.565a1.052,1.052,0,1,1,0-2.1h8.565a1.052,1.052,0,1,1,0,2.1m-17.131,0h-8.565a1.052,1.052,0,1,1,0-2.1h8.565a1.052,1.052,0,1,1,0,2.1m-17.13,0h-8.565a1.052,1.052,0,1,1,0-2.1h8.565a1.052,1.052,0,1,1,0,2.1m-17.131,0H96.356a1.052,1.052,0,1,1,0-2.1h8.565a1.052,1.052,0,1,1,0,2.1m-17.13,0H79.225a1.052,1.052,0,1,1,0-2.1h8.566a1.052,1.052,0,1,1,0,2.1m-17.131,0H62.1a1.052,1.052,0,1,1,0-2.1H70.66a1.052,1.052,0,1,1,0,2.1m-17.13,0H44.965a1.052,1.052,0,1,1,0-2.1H53.53a1.052,1.052,0,1,1,0,2.1",
    transform: "translate(-13.107 -70.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28430",
    "data-name": "Path 28430",
    d: "M464.289,236.895h-4.209a1.052,1.052,0,1,1,0-2.1h4.209a1.052,1.052,0,1,1,0,2.1",
    transform: "translate(-137.006 -70.078)",
    fill: "#fff"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16241",
    "data-name": "Group 16241",
    transform: "translate(-4335.781 -3377.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28264",
    "data-name": "Path 28264",
    d: "M64.381,15.327a5.707,5.707,0,0,0-2.73.69,9.875,9.875,0,0,0-13.307-4.836,14.184,14.184,0,0,0-26.137.456,10.276,10.276,0,0,0-3.151-.5c-5,0-9.056,3.517-9.056,7.856s4.054,7.858,9.056,7.858H64.381a5.763,5.763,0,1,0,0-11.526",
    transform: "translate(4349.032 3336.175)",
    fill: "#edf0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28265",
    "data-name": "Path 28265",
    d: "M74.111,29.43H43.123a.473.473,0,0,1,0-.946H74.111A5.29,5.29,0,1,0,71.6,18.537a.471.471,0,0,1-.656-.221,9.4,9.4,0,0,0-12.668-4.6.473.473,0,1,1-.409-.853A10.345,10.345,0,0,1,71.6,17.487,6.236,6.236,0,1,1,74.111,29.43",
    transform: "translate(4336.983 3332.819)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28266",
    "data-name": "Path 28266",
    d: "M39.417,39.173h-3a.473.473,0,0,1,0-.946h3a.473.473,0,0,1,0,.946",
    transform: "translate(4339.459 3323.076)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28267",
    "data-name": "Path 28267",
    d: "M23.689,25.066H15.1c-5.255,0-9.53-3.737-9.53-8.331S9.848,8.405,15.1,8.405a10.726,10.726,0,0,1,2.878.4A14.665,14.665,0,0,1,36.34.848a.473.473,0,0,1-.318.892A13.718,13.718,0,0,0,18.692,9.553a.473.473,0,0,1-.584.274A9.8,9.8,0,0,0,15.1,9.352c-4.733,0-8.584,3.313-8.584,7.383s3.851,7.385,8.584,7.385h8.586a.473.473,0,0,1,0,.946",
    transform: "translate(4350.666 3337.184)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28268",
    "data-name": "Path 28268",
    d: "M56.944,3.636a.468.468,0,0,1-.207-.048q-.262-.128-.531-.245a.473.473,0,1,1,.378-.868c.191.083.38.171.567.262a.473.473,0,0,1-.208.9",
    transform: "translate(4332.085 3336.284)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28269",
    "data-name": "Path 28269",
    d: "M193.622,66.543a3.923,3.923,0,0,1,1.863.469,6.729,6.729,0,0,1,9.067-3.295,9.668,9.668,0,0,1,17.815.311,6.973,6.973,0,0,1,2.148-.34c3.409,0,6.172,2.4,6.172,5.356s-2.763,5.356-6.172,5.356H193.622a3.928,3.928,0,1,1,0-7.856",
    transform: "translate(4282.717 3315.794)",
    fill: "#edf0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28270",
    "data-name": "Path 28270",
    d: "M199.95,71.938h-8.4a4.4,4.4,0,1,1,1.644-8.484,7.239,7.239,0,0,1,6.364-3.816,7.135,7.135,0,0,1,2.692.526,10.142,10.142,0,0,1,14.371-4.118.473.473,0,0,1-.5.806,9.2,9.2,0,0,0-13.213,4.123.472.472,0,0,1-.637.235,6.219,6.219,0,0,0-2.718-.625,6.291,6.291,0,0,0-5.715,3.69.473.473,0,0,1-.656.221,3.455,3.455,0,1,0-1.637,6.5h8.4a.473.473,0,1,1,0,.946",
    transform: "translate(4283.657 3317.051)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28271",
    "data-name": "Path 28271",
    d: "M232.088,75.289H213.757a.473.473,0,1,1,0-.946h18.331c3.143,0,5.7-2.19,5.7-4.882s-2.557-4.883-5.7-4.883a6.5,6.5,0,0,0-2,.317.473.473,0,1,1-.29-.9,7.464,7.464,0,0,1,2.292-.363c3.665,0,6.646,2.615,6.646,5.829s-2.981,5.828-6.646,5.828",
    transform: "translate(4274.012 3313.701)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28272",
    "data-name": "Path 28272",
    d: "M234.377,58.569a.472.472,0,0,1-.291-.1q-.175-.137-.357-.266a.473.473,0,1,1,.545-.773c.134.094.265.192.394.293a.473.473,0,0,1-.291.846",
    transform: "translate(4266.541 3316.021)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28273",
    "data-name": "Path 28273",
    d: "M393.406,26.863a6,6,0,0,1,2.854.719,10.315,10.315,0,0,1,13.9-5.051,14.821,14.821,0,0,1,27.311.476,10.709,10.709,0,0,1,3.293-.521c5.227,0,9.462,3.676,9.462,8.211s-4.236,8.209-9.462,8.209H393.406a6.022,6.022,0,0,1,0-12.044",
    transform: "translate(4209.761 3332.126)",
    fill: "#edf0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28274",
    "data-name": "Path 28274",
    d: "M400.879,39.1H388a6.5,6.5,0,1,1,2.635-12.432,10.85,10.85,0,0,1,9.642-5.922,10.671,10.671,0,0,1,4.248.879,15.3,15.3,0,0,1,21.78-6.422.473.473,0,0,1-.5.806,14.351,14.351,0,0,0-20.62,6.433.473.473,0,0,1-.638.235,9.774,9.774,0,0,0-4.275-.984,9.9,9.9,0,0,0-8.992,5.805.473.473,0,0,1-.656.221A5.549,5.549,0,1,0,388,38.157h12.878a.473.473,0,0,1,0,.946",
    transform: "translate(4211.93 3332.403)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28275",
    "data-name": "Path 28275",
    d: "M450.15,44.24h-28.1a.473.473,0,0,1,0-.946h28.1c4.957,0,8.99-3.471,8.99-7.737s-4.033-7.738-8.99-7.738a10.236,10.236,0,0,0-3.147.5.473.473,0,1,1-.291-.9,11.185,11.185,0,0,1,3.438-.544c5.479,0,9.936,3.9,9.936,8.684s-4.457,8.683-9.936,8.683",
    transform: "translate(4197.144 3327.266)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28276",
    "data-name": "Path 28276",
    d: "M453.658,18.606a.47.47,0,0,1-.29-.1q-.274-.213-.559-.414a.473.473,0,0,1,.546-.773q.3.214.6.441a.473.473,0,0,1-.292.846",
    transform: "translate(4185.69 3330.824)",
    fill: "#d0d5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28346",
    "data-name": "Path 28346",
    d: "M416.776,53.844h-1.808a.473.473,0,0,1,0-.946h1.808a.473.473,0,0,1,0,.946",
    transform: "translate(4199.756 3317.662)",
    fill: "#d0d5d8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGraphic);
export default __webpack_public_path__ + "static/media/background-graphic.b53751297feed2e4069f84f23addb0c6.svg";
export { ForwardRef as ReactComponent };